import { render, staticRenderFns } from "./DatasetName.vue?vue&type=template&id=2d3a5f45&scoped=true"
import script from "./DatasetName.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetName.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DatasetName.vue?vue&type=style&index=0&id=2d3a5f45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a5f45",
  null
  
)

export default component.exports